import React from 'react';
import { Block, Link } from 'framework7-react';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';

export default function Footer(props) {
  const { mobile, hideLogo, bigLogo, customFooterText, bottom } = props;

  return (
    <Block
      className={'pageFooter'}
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: mobile === false ? 90 : 20,
        color: '#666',
        position: bottom ? 'absolute' : undefined,
        bottom: 0
      }}
    >
      {!mobile && !hideLogo && (
        <div
          style={{
            textAlign: bigLogo ? 'center' : 'center',
            width: '100%',
            marginBottom: 20
          }}
        >
          <Link href={II18.get('portal_link')} target="_blank" external={true}>
            {bigLogo ? (
              <>
                <img src="/paperfly_word_logo.png" width={200} alt="Paperfly" />
              </>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'baseline' }}>
                <span
                  style={{
                    color: 'black',
                    paddingRight: 6,
                    fontSize: 14,
                    display: 'block',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Powered by
                </span>
                <img src="/paperfly_word_logo.png" height={20} alt="Paperfly" />
              </div>
            )}
          </Link>
          {bigLogo && (
            <div style={{ fontSize: 12, color: '#333' }}>
              {`${process.env.REACT_APP_NAME} v.${process.env.REACT_APP_VERSION}`}
            </div>
          )}
          {/*<Col style={{ textAlign: 'right' }}>
            powered
            <br />
            by
          </Col>
          <Col>
            <Link
              href="https://equinox-fintech.de"
              target="_blank"
              external={true}
            >
              <img
                style={{ height: 45 }}
                src="https://equinox-fintech.de/wp-content/uploads/2016/10/eqx_logo_black_trans_316x82.png"
                alt="Equinox FinTech Solutions"
              />
            </Link>
          </Col>*/}
        </div>
      )}

      {customFooterText ? (
        <div
          className={'htmlTextBlock'}
          style={{ textAlign: 'center', padding: 10 }}
          dangerouslySetInnerHTML={{ __html: customFooterText }}
        />
      ) : (
        /*this.props.showLinks &&*/ <p style={{ textAlign: 'center' }}>
          © {new Date().toLocaleDateString('de-DE', { year: 'numeric' })}
          &nbsp;
          <Link external href={II18.get('portal_link')} target="_blank">
            Paperfly
          </Link>{' '}
          |{' '}
          <Link external href="https://paperfly.io/imprint/" target="_blank">
            <II18>footer_imprint</II18>
          </Link>{' '}
          |&nbsp;
          <Link external href={II18.get('agb_link')} target="_blank">
            <II18>footer_conditions</II18>
          </Link>{' '}
          |{' '}
          {II18.locale() === 'de-DE' && (
            <>
              <Link
                external
                href="https://paperfly.io/privacy/"
                target="_blank"
              >
                <II18>footer_privacy</II18>
              </Link>{' '}
              |{' '}
            </>
          )}
          <Link external href={II18.get('contact_link')} target="_blank">
            <II18>footer_support</II18>
          </Link>
        </p>
      )}
    </Block>
  );
}

Footer.propTypes = {
  bottom: PropTypes.bool,
  mobile: PropTypes.bool,
  hideLogo: PropTypes.bool,
  bigLogo: PropTypes.bool,
  customFooterText: PropTypes.string
};
